import {css, html} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {ActivityQueueItem} from './activity-queue-item';
import {Panel} from './panel';
import {ri} from './runner-idle';
import {formatTime} from './utils';

@customElement('ri-activity-queue')
export class ActivityQueue extends Panel {
  override id = 'activity-queue';
  override name = 'Queue';
  override helpContent =
    'Ctrl + click = 5x, Shift + click = 10x, Ctrl + Shift + click = 50x';
  @state() activityQueue: ActivityQueueItem[] = [];
  @state() activityQueueIndex = 0;
  public static override styles = [
    ...Panel.styles,
    css`
      .container {
        height: calc(100% - 23px);
      }
    `,
  ];
  override setup(overrides = {}) {
    super.setup(overrides);
    this.settings = ri.settings.queue;
    this.subscribe('activityQueue', ri.activityQueue$);
    this.subscribe('activityQueueIndex', ri.activityQueueIndex$);
  }
  override render() {
    return super.render(html`<div class="fill scroll">
      <div class="flex-vertical">
        <div id="activity-queue-header">
          <select
            @change=${(event: Event) => {
              const batchNameEl = ri.shadowRoot?.getElementById(
                'batch-name-input'
              ) as HTMLInputElement;
              if (batchNameEl) {
                batchNameEl.value = '';
              }
              if (ri.lastLoadoutIndex != -1) {
                ri.loadouts[ri.lastLoadoutIndex] = this.activityQueue;
              }
              ri.lastLoadoutIndex = Number(
                (event.target as HTMLOptionElement)?.value
              );
              ri.beforeBatchLoadoutIndex = -1;
              ri.editingBatch = null;
              ri.activityQueue$.next(ri.loadouts[ri.lastLoadoutIndex]);
              ri.activityQueueIndex$.next(0);
              ri.requestUpdate();
            }}
          >
            ${ri.loadouts.map(
              (loadout, i) =>
                html`<option value=${i} ?selected=${ri.lastLoadoutIndex === i}>
                  Loadout ${i}
                </option>`
            )}
          </select>
          <span
            >${formatTime(
              this.activityQueue.reduce(
                (acc, queueItem, i) =>
                  i < this.activityQueueIndex
                    ? acc + queueItem.totalDuration
                    : acc,
                0
              ) + this.activityQueue[this.activityQueueIndex]?.activeIndex
            )}
            /
            ${formatTime(
              this.activityQueue.reduce((acc, q) => acc + q.totalDuration, 0)
            )}
          </span>
          <button
            @click=${() => {
              ri.activityQueue$.next([]);
              ri.requestUpdate();
            }}
          >
            Clear Queue
          </button>
        </div>
        <div id="activity-queue-container">
          ${ri.statusEffects} ${Object.values(this.activityQueue)}
        </div>
      </div>
    </div> `);
  }
}
